import { __assign } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import * as React from 'react';
import Dialog from '../../molecules/Dialog/Dialog.js';
import SimpleCookieForm from './SimpleCookieForm/SimpleCookieForm.js';
import ExpandedCookieForm from './ExpandedCookieForm/ExpandedCookieForm.js';

var CookieBanner = function (_a) {
    var open = _a.open, simpleFormCopy = _a.simpleFormCopy, expandedFormCopy = _a.expandedFormCopy, preferences = _a.preferences, onSavePreferences = _a.onSavePreferences;
    var _b = React.useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var allPreferencesActive = preferences.reduce(function (curr, preference) {
        curr[preference.id] = true;
        return curr;
    }, {});
    return (React.createElement(Dialog, { trigger: undefined, open: open, hideCloseButton: true, scrollContainer: true, align: "bottom", justify: "right", drawer: true, "data-testid": "CookieBanner" }, isExpanded ? (React.createElement(ExpandedCookieForm, __assign({}, expandedFormCopy, { preferences: preferences, onSavePreferences: onSavePreferences }))) : (React.createElement(SimpleCookieForm, __assign({}, simpleFormCopy, { onSavePreferences: function () {
            onSavePreferences(allPreferencesActive);
        }, onExpandPreferences: function () {
            setIsExpanded(true);
        } })))));
};

export { CookieBanner as default };
//# sourceMappingURL=CookieBanner.js.map
